import { useRef } from "react";

/**
 * Hook providing a stable identity object containing the latest values. These
 * values should **not** be accessed during render time.
 *
 * @param values Object containing all values.
 * @returns Stable identity object containing said values.
 */
export function useLatestValues<T extends Record<keyof T, unknown>>(
  values: T,
): T {
  const valuesRef = useRef<T>({} as T);
  // eslint-disable-next-line react-hooks/refs
  Object.assign(valuesRef.current, values);
  // eslint-disable-next-line react-hooks/refs
  return valuesRef.current;
}
